export type GovernanceVisibilitySettings = {
  contentPolicyLicensed?: boolean;
};

/**
 * Governance is unlocked by the organisation's Content Policy licence. The
 * legacy `showGovernance` setting is deliberately not consulted any more.
 */
export function isGovernanceVisible(
  settings: GovernanceVisibilitySettings | undefined,
): boolean {
  return settings?.contentPolicyLicensed === true;
}
